import { get, post } from './_core'

export function countries() {
    return get('/countries')
}

export function cities(countryId) {
    return get(`/cities/${countryId}`).then(result=>result.values)
}

export function updates() {
    return get('/updates')
}

export function users(ids) {
    return post('/users', {
        ids: Array.isArray(ids) ? ids : [ids]
    })
}

export function dashboard() {
    return get('/dashboard')
}